import { map, tap } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { UserService } from '../../../../services/user/user.service';
import { Injector } from '@angular/core';
import { EducationalPathItemDTO } from '../../../../dto/educational-path/educational-path-item.dto';
import { ProfilePathItemDTO } from '../../../../dto/educational-path/profile-path-item.dto';
import { EducationalPathUserDTO } from '../../../../dto/educational-path/educational-path-user.dto';

// Extended interface to match the actual data structure
interface ExtendedEducationalPathItemDTO extends EducationalPathItemDTO {
    id: number;
    type: string;
    descriptions: any[];
    visibility: string;
    organizations_id: number;
    version_start_date: string;
    version_end_date: string | null;
    base_id: number | null;
    deleted: boolean;
    locked: boolean;
    status: string;
}

export function profile_paths_brs(componentDataSourceService: ComponentDataSourceService & { injector: Injector }) {
    const userService = componentDataSourceService.injector.get(UserService);

    return {
        name: 'Beredskabsstyrelsen',
        description: 'Vedligeholdelsesmoduler fra Beredskabsstyrelsen',
        execute: () => {
            return userService.getEducationalPaths().pipe(
                tap((paths: EducationalPathUserDTO[]) => {
                }),
                map((paths: EducationalPathUserDTO[]) => {
                    const filteredPaths = paths.filter(path => path.organizations_id === 1 || path.organizations_id === 0);
                    
                    const items = filteredPaths.flatMap(path => [
                        ...path.maintenance,
                        ...path.requirements
                    ]).map(item => item as unknown as ExtendedEducationalPathItemDTO);
                    
                    return items
                        .filter(item => item.id > 0) // Only show positive IDs for BRS organizations
                        .map((item): ProfilePathItemDTO => {
                            return {
                                name: item.name,
                                subtypes: '',
                                participation_status: item.completed ? 'Gennemført' : 'Ikke gennemført',
                                type: 'Fastsat',
                                module_name: item.name,
                                item_id: item.id,
                                completed: item.completed
                            };
                        });
                })
            );
        },
        settings: {
            columns: [
                { 
                    key: 'name', 
                    header: 'Modul', 
                    type: 'text-with-subtitle',
                    subtitle: 'subtypes'
                },
                { key: 'participation_status', header: 'Status', type: 'text' },
                { key: 'type', header: 'Type', type: 'text' },
                {
                    key: 'module_name',
                    header: '',
                    type: 'button',
                    buttonText: 'Find tilmelding',
                    buttonColor: 'primary',
                    alignment: 'right',
                    variant: 'raised',
                    action: (row: any) => {
                        const searchParams = new URLSearchParams({
                            search: row.module_name,
                            type: 'module'
                        });
                        window.location.href = `/events?${searchParams.toString()}`;
                    }
                }
            ],
            pageable: false,
            sortable: false,
            rowHover: true,
            defaultSortColumn: 'name',
            defaultSortDirection: 'asc'
        }
    };
} 